import { HubConnection } from '@microsoft/signalr';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SendWebsocketMessage } from '../../../utils/websocketHelper';

export interface SendSupportThreadMessageThunkArg {
    connection: HubConnection;
    threadId: number;
    htmlContent: string;
    attachmentsIds: number[];
}

export const sendSupportThreadMessage = createAsyncThunk(
    'supportMessages/send',
    async (arg: SendSupportThreadMessageThunkArg) => {
        let newMessage = {
            threadId: arg.threadId,
            htmlContent: arg.htmlContent,
            attachmentsIds: arg.attachmentsIds,
        };
        await SendWebsocketMessage(arg.connection, 'SR_SendMessage', newMessage);
    }
);
